// @ts-nocheck
/* eslint-disable */
export const llaPlatformHourClockTickIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 8.75V12L10.75 13.25M19.25 14.75C19.25 14.75 17.3214 16.8393 16.3571 19.25L14.75 17.3214M11.25 19.25L11 19.1816C7.46916 18.6945 4.75 15.6648 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C15.6648 4.75 18.6945 7.46916 19.1816 11L19.2148 11.2539" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'hour-clock-tick' as const
};